export default __webpack_public_path__ + "static/media/account.47cca873.svg";